import type { DockerConnectorHosting } from "@p0security/integrations-docker-shared/types";

/** A connector image on Docker Hub, pinned by the digest its tag resolves
 * to. */
export type ConnectorImage = Readonly<{
  /** `sha256:<digest>` */
  digest: string;
  name: string;
  tag: string;
}>;

/** The connector build each cloud deploys: one image for AWS Lambda and one
 * for Cloud Run, built from the same service.
 *
 * Each is a p0-security-perimeter build of the connector, by its
 * `sha-<commit>` tag on Docker Hub and the digest that tag resolves to
 * (`docker buildx imagetools inspect <name>:<tag>`). The service's source has
 * moved to `submodules/connector`, but these pins still name perimeter builds
 * until they're moved to that repo's images. */
export const CONNECTOR_IMAGES: Readonly<
  Record<DockerConnectorHosting["type"], ConnectorImage>
> = {
  aws: {
    digest:
      "sha256:dabe54d8bbae4cbae011c3959cfdb6341469b4089f52274c45811b441192a2f6",
    name: "p0security/p0-connector-docker",
    tag: "sha-d9ff0fc",
  },
  gcp: {
    digest:
      "sha256:56c1fdbb39237d101104bdebb9832d412e758730e64784644474eaa495a02509",
    name: "p0security/p0-connector-docker-gcloud",
    tag: "sha-d9ff0fc",
  },
};
